import { Component, ChangeDetectionStrategy, Input, OnInit } from '@angular/core';
import { IPageFacets } from '../../models/filter.models';
import { SettingsService, SiteIds } from '../../core/settings.service';
import { takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { LEASING_PLAN_TYPES, LeasingService } from '../../leasing/leasing.service';
import { FILTER_FACET } from '../../filter-service/filter.models';

@Component({
    selector: 'app-facet-list',
    templateUrl: './facet-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacetListComponent implements OnInit {
    @Input() facets: IPageFacets | null;
    @Input() onMobile?: boolean;

    public FILTER_FACET = FILTER_FACET;

    site: string;
    siteIds = SiteIds;
    LeasingPlanTypes = LEASING_PLAN_TYPES;
    activeLeasingPlan$: Observable<any>;
    private unsubscribe = new Subject<void>();

    constructor(
        private settingsService: SettingsService,
        private leasingService: LeasingService) {
        this.activeLeasingPlan$ = this.leasingService.getActiveLeasingToggles();
    }

    ngOnInit(): void {
        this.settingsService
        .get()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((settings) => {
            this.site = settings.siteNameId;
        });
    }
}
